// shim to assure socket-io client is loaded before K4. The ReactNative bundler likes to change the order of imports
if (typeof global == 'object') {
	if (Object.defineProperty) {
		Object.defineProperty(window.navigator, 'userAgent', {
			configurable: true,
			get: function () {
				return "react-native";
			}
		})
	};

	global.io = require('socket.io-client');
}

var k4model = (function (socket) {
	'use strict';

	socket = socket && socket.hasOwnProperty('default') ? socket['default'] : socket;

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}

	var helper = {
		get isNode()
		{
			return (typeof process !== 'undefined' && process.versions && process.versions.node);
		},

		get isCloud() 
		{
			return (this.isNode && process.env.IS_CLOUD);
		}
	};
	var helper_1 = helper.isNode;
	var helper_2 = helper.isCloud;

	var _empty_module = {};

	var _empty_module$1 = /*#__PURE__*/Object.freeze({
		'default': _empty_module
	});

	var require$$2 = getCjsExportFromNamespace(_empty_module$1);

	const { isNode, isCloud } = helper;

	/**
	 * @class K4.util
	 * Utility functions.
	 * @singleton
	 */


	class Util {


		constructor()
		{
			if(isNode && !isCloud && process.env['K4HOME'])
			{
				this.setConfig = this._setConfig;
				this.getConfig = this._getConfig;
				this.clearConfig = this._clearConfig;
				this.keychain = require$$2;
			}
		}
		
		/**
		 * @method guid
		 * Returns a guid string.
		 *
		 */


		guid()
		{
			let dt = new Date().getTime();
			let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				let r = (dt + Math.random()*16)%16 | 0;
				dt = Math.floor(dt/16);
				return (c=='x' ? r :(r&0x3|0x8)).toString(16);
			});
			return uuid;
		}

		/**
		 * @method secondsToTime
		 * Converts seconds to a string formated as 0h 0m 0s.
		 * @param {Number} secs Seconds.
		 *
		 */

		secondsToTime(secs)
		{
			if(secs < 0) {
				return `-(${this.secondsToTime(-secs)})`;
			}
		
			let hours = Math.floor(secs / (60 * 60));

			let divisor_for_minutes = secs % (60 * 60);
			let minutes = Math.floor(divisor_for_minutes / 60);

			let divisor_for_seconds = divisor_for_minutes % 60;
			let seconds = Math.ceil(divisor_for_seconds);

			if(hours > 0)
			{
				return hours + "h " + minutes + "m " + seconds + "s";
			} else if(minutes > 0) {
				return minutes + "m " + seconds + "s";
			} else {
				return seconds + "s";
			}


		}

		/**
		 * @method setConfig Securely stores local key / value data for a bridge.
		 * @param {String} key The key.
		 * @param {String} value The value.
		 * @return {Boolean} success
		 * @bridgeonly
		 */

		_setConfig(key, value)
		{
			if(value === null)
			{
				return this.keychain.deleteValue(key);
			} else {
				return this.keychain.setValue(key, value);
			}


		}


		/**
		 * @method clearConfig Clears local key / value data for a bridge.
		 * @param {String} key The key.
		 * @return {Boolean} success
		 * @bridgeonly
		 */

		_clearConfig(key)
		{
			return this.keychain.deleteValue(key);

		}

		/**
		 * @method getConfig Securely stores local key / value data for a bridge.
		 * @param {String} key The key.
		 * @return {String} value
		 * @bridgeonly
		 */

		_getConfig(key)
		{

			return this.keychain.getValue(key);

		}
	}


	var util = Util;

	const { isNode: isNode$1, isCloud: isCloud$1 } = helper;

	class Endpoints {

		constructor()
		{
			this.nonProductionEnvironments = [ 'dev', 'test', 'staging', 'prerelease' ];
			this.productionEnvironments = [ 'prod', '', null, undefined ];
		}

		getLocalKeychain() {

			if(typeof this.keychain !== 'undefined') {
				return this.keychain;
			} else {
				if ( isNode$1 ) {
					try {
						this.keychain = require$$2;
						return this.keychain;
					} catch ( e ) {
						console.warn('Error loading local keychain: ' + e);
						return null;
					}
				} else {
					console.warn('Local keychain is only available in NodeJS environment');
					return null;
				}
			}
		}

		buildServiceUrl (environment, serviceName) {

			if ( this.nonProductionEnvironments.indexOf(environment) !== -1 ) {
				return 'https://api-' + environment + '.k4connect.com/' + serviceName;
			} else if ( this.productionEnvironments.indexOf(environment) !== -1 ) {
				return 'https://api.k4connect.com/' + serviceName;
			} else {
				return 'http://' + environment + '/' + serviceName;
			}
		}

		buildCustomUrl (environment, nonProduction, production, local) {

			if ( this.nonProductionEnvironments.indexOf(environment) !== -1 ) {
				return nonProduction;
			} else if ( this.productionEnvironments.indexOf(environment) !== -1 ) {
				return production;
			} else {
				return local;
			}
		}

		getKeychain(force) {

			let environment = this.getStaging(force) ? 'staging' : this.getEnvironment();
			return this.buildServiceUrl(environment, 'v2/keychain');
		}

		getSso(force) {

			let environment = this.getStaging(force) ? 'staging' : this.getEnvironment();
			return this.buildServiceUrl(environment, 'v2/sso');
		}

		getContent(force) {

			let environment = this.getStaging(force) ? 'staging' : this.getEnvironment();
			return this.buildServiceUrl(environment, 'v2/content');
		}

		getRemote(force)
		{
			let environment = this.getStaging(force) ? 'staging' : this.getEnvironment();
			return this.buildCustomUrl(
				environment,
				'https://remote-' + environment + '.k4connect.com',		// non-production
				'https://remote.k4connect.com',						// production
				'http://' + environment + '/v2/remote'					// local
			);
		}

		getAuth(force)
		{
			if ( this.getStaging(force) ) {
				return 'https://auth-staging.k4connect.com';
			} else {
				return 'https://auth.k4connect.com';
			}
		}

		getProvisioning(force, gateway)
		{
			if ( gateway === undefined ) {
				gateway = true;
			}

			let environment = this.getEnvironment();
			if ( gateway ) {
				let shouldUseStaging = this.getStaging(force);

				if (force === true) {
					return this.buildServiceUrl((shouldUseStaging === true ? 'staging' : environment), 'v2/provision');
				} else {
					// NOTE: Should use the specified environment, and then
					// staging (unforced), with final fallback being 'prod'
					return this.buildServiceUrl(environment || (shouldUseStaging ? 'staging' : 'prod') , 'v2/provision');
				}
			}

			return this.buildCustomUrl(
				environment,
				'https://provision-' + environment + '.k4connect.com',	// non-production
				'https://provision.k4connect.com',					// production
				'http://' + environment + '/v2/provision'				// local
			);
		}

		getOnboarding(force)
		{
			let staging = this.getStaging(force);

			if ( staging ) {
				return 'https://onboarding-staging.k4connect.com/#!/onboarding';
			}

			let environment = this.getEnvironment();

			return this.buildCustomUrl(
				environment,
				'https://onboarding-' + environment + '.k4connect.com/#!/onboarding',	// non-production
				'https://onboarding.k4connect.com/#!/onboarding',					// production
				'http://' + environment + '/onboarding/#!/onboarding'					// local
			);
		}

		getHomeUIVersion(force)
		{
			let staging = this.getStaging(force);

			if ( this.getStaging(force) ) {
				return 'https://s3.amazonaws.com/com.k4connect.versions/staging';
			} else {
				return 'https://s3.amazonaws.com/com.k4connect.versions/production';
			}
		}

		getEnvironment() {

			let source;

			if ( isNode$1 ) {
				let keychain = this.getLocalKeychain();
				if ( !keychain ) {
					return 'prod';
				}
				source = keychain.getValue('initial');
			} else {
				if ( typeof settings == 'object' && settings.sso ) {
					return settings.sso.environment;
				}
				source = localStorage.getItem('k4Local.cachedCredentials');
			}

			if ( !source ) {
				return 'prod';
			}

			try {
				let data = JSON.parse(source);
				return data.environment;
			} catch ( err ) {
				console.error('Failed to parse source data');
				return 'prod';
			}
		}


		getStaging(force) {
			if ( typeof force != 'undefined' ) {
				return (force == true);
			}

			if ( isNode$1 ) {
				let keychain = this.getLocalKeychain();
				if ( !keychain ) {
					return false;
				}

				let initial = keychain.getValue('initial');
				if ( initial ) {
					let s;
					try {
						s = JSON.parse(initial);
					} catch ( e ) {
						console.error('Failed to parse initial in endpoints');
						return false;
					}
					return (s.staging == true);
				}
			} else {
				// try to find global settings object
				if ( typeof settings == 'object' && settings.sso ) {
					return (settings.sso.staging == true);
				}

				let json = localStorage.getItem('k4Local.cachedCredentials');

				if ( json ) {
					let cachedCredentials;
					try {
						cachedCredentials = JSON.parse(json);
					} catch ( e ) {
						console.error('Failed to parse cachedCredentials in endpoints');
						return false;
					}

					return (cachedCredentials.staging == true);
				}
			}

			return false;
		}
	}





	var endpoints = Endpoints;

	class Events {

		constructor(config)
		{
			this.events = {};

			this.connected = false;
			this.ready = false;


			if(config.listeners)
			{
				for(let i in config.listeners)
				{
					this.on(i, config.listeners[i]);
				}
			}

		}

		on(event, callback, scope) {

			this.events[event] = this.events[event] || [];
			for(let i=0; i < this.events[event].length; i++)
			{
				let e = this.events[event][i];
				if(e.f.toString() === callback.toString())
				{
					//already registered
					this.logging.debug('Callback already registered.', event);
					return;
				}
			}

			this.events[event].push({
				f : callback,
				s : scope
			});

			

		}

		off(event, callback) {
			if (this.events[event]) {
				let listeners = this.events[event];
				for (let i = listeners.length - 1; i >= 0; --i) {
					if (listeners[i].f === callback) {
						listeners.splice(i, 1);
					}
				}
			}
		}


		dispatch(event, args) {

			switch(event)
			{
				case 'ready':
					this.ready = true;
					this.updateServerDevice();
				break;
				case 'connected':
					this.connected = true;
				break;
				case 'disconnected':
					this.connected = false;
					this.ready = false;
				break;
			}

			if (this.events[event] && this.events[event].length > 0) {

				let listeners = this.events[event], len = listeners.length;
				while (len--) {
					let s = (listeners[len].s) ? listeners[len].s : this;
					listeners[len].f.apply(s, args);
				}
			}
		}
	}

	var events = Events;

	const THRESHOLD = 1000 * 60 * 30;

	/**
	 * @class K4.Watchdog
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#watchdog}.
	 */



	/**
	 * @method Watchdog
	 * Creates a new Watchdog object
	 * @param {K4} parent The base K4 object.
	 * @return {K4.Watchdog}
	 */

	 class Watchdog {

		constructor(parent)
		{
			this.parent = parent;
			this.config = parent.config;
			this.logging = parent.logging;

			this.timer = setInterval(()=>{

				//skip if client watchdog is not initialized (cloud, etc)
				if(!this.last)
				{
					return;
				}

				const now = Date.now();
				const delta = now - this.last;

				this.logging.debug(`Watchdog ran with time delta of ${delta} ms, threshold of ${THRESHOLD}`);

				//exit if delta is more than threshold
				if(delta > THRESHOLD)
				{
					this.logging.fatal('Client watchdog triggered.');
				}

			}, 60000);
			
			
		}

		kick()
		{
			this.last = Date.now();
		}

		close()
		{
			clearInterval(this.timer);
		}
	 }


	var watchdog = Watchdog;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin = {
		 
	    /**
		 * @method add Adds a node.
		 * @param {String} name The name.
		 * @param {String} description The json description.
		 * @param {Function} [callback] Callback function.
		 * @param {String} callback.err Error encountered. null on success.
		 */

		add(name, description, callback)
		{

			let { promiseId, promise, done } = this.registerCallback(callback);

			this.logging.debug('Add: Adding ' + name + " to " + this._name);

			if(!name)
			{
				return done("Invalid name.");
			}

			if(this.child(name))
			{
				return done('Name already exists.');
			}

			//from the api
			this._socket.emit('message', {
				type: 'add',
				path: this.path(),
				name: name,
				description: description,
				from: this.config.from,
				callback: {
					promiseId: promiseId,
					origin: this.config.from
				}
			});

			return promise;

		},

		_add(name, description, done)
		{

			this.logging.debug('Add: Added ' + name + " to " + this._name);

			//from the message queue

			if(typeof description == 'string')
			{
				//json
				try {
					description = JSON.parse(description);
				} catch (e) {
					done('Failed to parse json string.');
				}
			}

			//get the value of the node
			let temp = {};
			temp[name] = description;

			//import it
			this.import(temp);

			if(typeof done == 'function') { done(); }

		}
		
	};

	var add = mixin;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$1 = {
		 

		/**
		 * @method push Adds a new child. Can only be called on object types.
		 * @param {String/Boolean/Number} name The value.
		 * @param {Object/String/Boolean/Number} value The initial value.
		 * @param {Function} [callback] Callback function.
		 * @param {String} callback.err Error encountered. null on success.
		 * @param {K4.Child} callback.child The new child.
		 */

		push(name, value, callback) {

			let { promiseId, promise, done } = this.registerCallback(callback);

			if(typeof this._value == "object" && this._value != null && !Array.isArray(this._value))
			{

				let node = this._push(name, value);

				done(null, node);

			} else {
				done('Only object nodes can have children');
			}

			return promise;
		},


		_push(name, value)
		{
			this._value[name] = value;
			this._children[name] = new Child(name, this._value[name], this, this._socket);

			return this._children[name];
		},

		/**
		 * @method export Returns a json string of the current value.
		 * @returns {String} json
		 */

		export()
		{
			this.logging.debug('Child: Export');
			let json;
			try {
				json = JSON.stringify(this._value, null, 4);
			} catch (e) {
				return null;
			}

			return json;
		},

		/**
		 * @method import Import saved data into the node. Automatically creates child nodes based on the imported data's structure.
		 * @param {String/Object} data A json string or object.
		 */

		import(data, callback)
		{

			let { promiseId, promise, done } = this.registerCallback(callback);

			this.logging.debug('Child: Import', data);

			if(typeof data == 'string')
			{
				//json
				try {
					data = JSON.parse(data);
				} catch (e) {
					done('Failed to parse json string.');
				}
			}

			this.importObj(data, this);

			this._dispatch("value", [this.value(), this.path()]);

			done();

			return promise;

		},

		importObj(obj, base)
		{

			for(let i in obj)
			{
				if(typeof obj[i] == 'object' && obj[i] != null && !Array.isArray(obj[i]))
				{


					if(i == 'meta')
					{
						if(obj[i].cls && !obj[i].guid)
						{
							//create a guid
							obj[i].guid = this._socket.parent.util.guid();
						}


						for(let j in obj[i])
						{
							switch(j)
							{
								case 'group':
									let group = obj[i].group;
									if(!this._root.groups[group])
									{
										this._root.groups[group] = [];
									}
									this._root.groups[group].push(base);

								break;
								case 'cls':
									let cls = obj[i].cls;
									if(!this._root.classes[cls])
									{
										this._root.classes[cls] = [];
									}
									this._root.classes[cls].push(base);

								break;
								case 'guid':
									let guid = obj[i].guid;
									this._root.guids[guid] = base;

								break;
								case 'paths':
									this.createPaths(obj[i].paths, base);
								break;


							}


						}
					}

					let child = base._push(i, {});
					this.importObj(obj[i], child);

				} else {

					let child = base._push(i, obj[i]);
					//setup paths for leaf nodes
					let meta = child.meta();
					if(meta && meta.paths)
					{
						this.createPaths(meta.paths, child);
					}
				}
			}
		}

	};

	var construct = mixin$1;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$2 = {
	     
	    /**
		 * @method fire Fires an event node.
		 * @param {String|Object|Array} [args] Optional args. Arrays will be applied as multiple arguments on handler.
		 * @param {Function} [callback] Callback function.
		 */

		fire(args, callback)
		{
			
			if(typeof args == 'function')
			{
				callback = args;
				args = null;
			} else if(!Array.isArray(args))
			{
				//single arg, wrap in array
				args = [args];
			}



			let { promiseId, promise, done } = this.registerCallback(callback);


			this.logging.debug('Child: Fire ' + this.path());

			let meta = this.meta();
			let type;

			
			if(meta && !type)
			{
				type = meta.type;
			}

			if(type != 'event')
			{
				return done('Only events can be fired.');
			}

	        this._socket.emit('message', {
	            type: 'fire',
	            data: {
	                path: this.path(),
	                args: args
	            },
	            from: this.config.from
	        });

	        return promise;
		

	    },
	    
	    _fire(data, from, done)
	    {
			let path = this.path();

			this.logging.debug('Child: Fired ' + path);
			
			let args = data.args;

			if(Array.isArray(args))
			{
				//make sure args array element one is path
				if(args[0] !== path)
				{
					args.unshift(path);
				}
			} else {
				args = [ path, args ];
			}


	        this._dispatch("fire", args);
	        this.log(data.path, data.args, from);


	        done(null, {});
	        
		},
		

		/**
		 * @method on Subscribes to events on the node. Unhandled events will bubble up to the first node above this has an event listener.
		 * @param {String} event The event name.
		 * @param {Function} handler The event handler.
		 * @param {Object} [scope] Scope of handler. Defaults to <i>this</i>.
		 */

		on(event, handler, scope) {

			this.logging.debug('Child: On ' + event);

			if(!this._root._events[event])
			{
				this._root._events[event] = {};
			}

			let path = this.path();

			if(!this._root._events[event][path])
			{
				this._root._events[event][path] = [];
			}

			let handlers = this._root._events[event][path];

			let key = handler.toString();

			for(let i=0; i < handlers.length; i++)
			{
				let existing = handlers[i];
				if(existing.f.toString() === key)
				{
					//already registered
					return;
				}
			}

			handlers.push({
				f : handler,
				s : scope
			});


		},

		/**
		 * @method once Subscribes to a single occurrence of an event on the node. Unhandled events will bubble up to the first node above this has an event listener.
		 * @param {String} event The event name.
		 * @param {Function} handler The event handler.
		 * @param {Object} [scope] Context of handler. Defaults to <i>this</i>.
		 */

		once(event, handler, scope) {
			// NOTE: this.dispatch() will apply the appropriate scope to the
			// onFirstEvent() wrapper, which then is passed directly into the
			// original callback/handler for the event subscribed to

			var that = this;
			this.on(event, function onFirstEvent(){
				that.off(event, onFirstEvent);
				handler.apply(scope || that, arguments);
			}, scope);
		},

		/**
		 * @method off Unsubscribes from events on the node.
		 * @param {String} event The event name.
		 * @param {Function} handler The event handler.
		 */

		off(event, handler) {

			this.logging.debug('Child: Off ' + event);

			let path = this.path();

			if(this._root._events[event] && this._root._events[event][path])
			{
				let handlers = this._root._events[event][path];
				let key = handler.toString();

				for (let i = handlers.length - 1; i >= 0; --i) {
					if (handlers[i].f.toString() === key) {
						handlers.splice(i, 1);
					}
				}
			}

		},


		_dispatch(event, args) {

			let path = this.path();	

			if (this._root._events[event] && this._root._events[event][path] && this._root._events[event][path].length > 0) {

				let handlers = this._root._events[event][path];
				let len = handlers.length;

				while (len--) {
					let s = (handlers[len].s) ? handlers[len].s : this;
					handlers[len].f.apply(s, args);
				}
			} else {
				if(this._parent)
				{
					this._parent.fireEvent(event, args);
				}
			}
		},

		/**
		 * @method fireEvent Manually fire an event.
		 * @param {String} event The event name.
		 * @param {Array} [args] Optional args array. Some events, like 'value', no not accept args.
		 */

		fireEvent(event, args)
		{

			switch(event) {
				case "value":
					//value events should send the local node value and path
					this._dispatch("value", [this.value(), this.path()]);
				break;
				default:
				this._dispatch(event, args);
				break;
			}
		},

		/**
		 * @method listeners Returns all subscribed handlers.
		 * @param {String} event The event name.
		 * @returns {Object[]} listeners
		 */

		listeners(event)
		{
			let path = this.path();

			if(this._root._events[event] && this._root._events[event][path])
			{
				return this._root._events[event][path];
			}
			return [];
		}

		
	};

	var events$1 = mixin$2;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$3 = {
		 

		/**
		 * @method receiver Returns the receiver.
		 * @returns {K4.Child} receiver
		 */

		receiver()
		{
			let node;

			let meta = this.meta();
			if(meta && meta.receiver)
			{
				if(meta.receiver == 'self')
				{
					node = this;
				} else {
					let receiver = this.child(meta.receiver).value();
					node = this._root.child(receiver);
				}

			}

			return node;
		},

		/**
		 * @method senders Returns senders to this node.
		 * @returns {K4.Child[]} senders
		 */

		senders()
		{
			let nodes = [];

			for(let i in this._root.guids)
			{
				let node = this._root.guids[i];
				let receiver = node.receiver();

				if(receiver == this && node != this)
				{
					nodes.push(node);
				}
			}

			return nodes;
	    },

	    /**
		 * @method execute Execute a function node.
		 * @param {Object} [args] Args object.
		 * @param {Function} [callback] Callback function.
		 */

		execute(args, callback, path, type)
		{

			//set path on first call
			if(!path)
			{
				path = this.path();
			}

			

			if(typeof args == 'function')
			{
				callback = args;
				args = null;
			}

			let { promiseId, promise, done, cancel } = this.registerCallback(callback);

			if(this == this._root)
			{
				return done('No receiver found');
			}

			let meta = this.meta();

			if(meta && !type)
			{
				type = meta.type;
			}

			if(type != 'function')
			{
				return done('Only functions can be executed');
			}

			if(meta && meta.receiver)
			{
				let receiver;

				if(meta.receiver == 'self')
				{
					receiver = this.meta().guid;
				} else {
					let node = this.child(meta.receiver);
					//get the property or variable node
					if(node)
					{
						let value = node.value();
						if(value)
						{
							let child = this._root.child(value);
							if(child)
							{
								//get the guid of the receiver node
								receiver = child.meta().guid;
							}
						}
					}
				}

				if(receiver)
				{
					this.logging.debug('Child: Execute,', path, args, promiseId);
					this._socket.emit('message', {
						type: 'execute',
						data: {
							path: path,
							args: args
						},
						receiver: receiver,
						callback: {
							promiseId: promiseId,
							origin: this.config.from
						},
						from: this.config.from
					});

				} else {
					return done('Invalid receiver.');
				}
				return promise;

			} else {

				//hand up chain until reaches a node that will handle it
				if(this._parent)
				{
					//resolve this promise, we will return the inner one
					cancel();
					return this._parent.execute(args, callback, path, type);
				}
			}

			
			

		}
	    
	};

	var execute = mixin$3;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$4 = {
		 
	    message(data){

			this.logging.debug('Child: Message', data);

			let child;

			switch(data.type)
			{
				case 'initial':

					this.createGroups();
					this.import(data.value);
					if(this._socket.parent)
					{
						this._socket.parent.dispatch('ready', [ this ]);
					}

				break;
				case 'set':
					child = this.child(data.path);
					if(child)
					{
						child._set(data.value, (e, d) => {
							this.checkCallback(data.callback, e, d);
						}, false, false, data.from);
					}
				break;
				case 'rename':
					child = this.child(data.path);
					if(child)
					{
						child._rename(data.name, (e, d) => {

							this.checkCallback(data.callback, e, d);
							child.fireEvent("rename", [data]);
							this.fireEvent("log", [data]);
						});

					}
				break;
				case 'add':
					child = (data.path == '' || data.path == '/') ? this : this.child(data.path);
					if(child)
					{
						child._add(data.name, data.description, (e, d) => {
							this.checkCallback(data.callback, e, d);
							child.fireEvent("add", [data]);
							this.fireEvent("log", [data]);
						});

					}
				break;

				case 'remove':
					child = this.child(data.path);
					if(child)
					{
						child._remove(data.name, (e, d) => {
							this.checkCallback(data.callback, e, d);
							child.fireEvent("remove", [data]);
							this.fireEvent("log", [data]);
						}, true);

					}



				break;
				case 'move':
					child = this.child(data.path);
					if(child)
					{
						child._move(data.name, data.destination, (e, d) => {
							this.checkCallback(data.callback, e, d);
							child.fireEvent("move", [data]);
							this.fireEvent("log", [data]);
						});

					}
				break;
				case 'upgrade':
					child = this.child(data.path);
					if(child)
					{
						child._upgrade(data.json, data.name, (e, d) => {
							this.checkCallback(data.callback, e, d);
							child.fireEvent("upgrade", [data]);
							this.fireEvent("log", [data]);
						});

					}
				break;
				case 'update':
					child = this.child(data.path);
					if(child)
					{
						child._update(data.value, (e, d) => {
							this.checkCallback(data.callback, e, d);
						}, false, data.from);
					}
				break;
				case 'execute':

					let receiver = data.from;
					let callback = data.callback;

					let node = this._root.guids[data.receiver];

					node._dispatch("execute", [data.data, (err, data) => {

						this._socket.emit('message', {
							type: 'reply',
							receiver: receiver,
							callback: callback,
							err: err,
							data: data,
							from: this.config.from
						});

					}]);
				break;
				case 'fire':
					child = this.child(data.data.path);
					if(child)
					{
						child._fire(data.data, data.from, (e, d) => {
							this.checkCallback(data.callback, e, d);
						});
					}
				break;
				case 'reply':
					this.checkCallback(data.callback, data.err, data.data);
				break;
			}

		}
		
	};

	var message = mixin$4;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$5 = {
		 

		/**
		 * @method move Moves a child. Can only be called on object types.
		 * @param {String} name The child to move.
		 * @param {String} destination The destination path.
		 * @param {Function} [callback] Callback function.
		 * @param {String} callback.err Error encountered. null on success.
		 */

		move(name, destination, callback)
		{

			let { promiseId, promise, done } = this.registerCallback(callback);

			//enforce restriction here
			this.logging.debug('Child: Moving ' + name + " to " + destination);

			let target = this._root.child(destination);
			
			if(!target)
			{
				return done("Invalid destination");
			}

			let node = this.child(name);
			if(!node)
			{
				return done("Invalid child name");
			}

			//from the api
			this._socket.emit('message', {
				type: 'move',
				path: this.path(),
				name: name,
				destination: destination,
				callback: {
					promiseId: promiseId,
					origin: this.config.from
				},
				from: this.config.from
			});

			return promise;
		},

		_move(name, destination, done)
		{

			this.logging.debug('Child: Moved ' + name + " to " + destination);
			//from the message queue
			let target = this._root.child(destination);
			let node = this.child(name);

			//get the value of the node
			let temp = {};
			temp[name] = node.value(true);

			//remove it
			this._remove(name);

			//reimport it
			target.import(temp);

			if(typeof done == 'function') { done(); }
		}
	};

	var move = mixin$5;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$6 = {
		 
	    /**
		 * @method oid Returns the nodes oid.
		 * @returns {String} oid
		 */

		oid(skip)
		{

			let parts = [];

			if(this == this._root)
			{
				return "";
			}


			let meta = this.meta();

			if(!skip && (!meta || !meta.oid))
			{
				//return on top level requests this dont have an oid
				return;
			}

			//if a device has a receiver bridge, follow it
			if(meta && meta.receiver && meta.receiver != 'self')
			{
				let receiver = this.child(meta.receiver);

				if(!receiver)
				{
					this.logging.error('Child: Unset oid receiver', this.path());
					return;
				}

				let node = this._root.child(receiver.value());

				if(!node)
				{
					this.logging.error('Child: Unset oid receiver node', this.path());
					return;
				}

				let t = node.oid();

				if(typeof t != 'string')
				{
					this.logging.error('Child: Invalid receiver oid', this.path());
					return;
				}

				add$1(parts, t);

			} else {

				let p = this._parent.oid(true);

				if(typeof p != 'string')
				{
					this.logging.error('Child: Invalid parent oid', this.path());
					return;
				}
				if(p != "")
				{
					add$1(parts, p);
				}
			}

			


			if(meta && meta.oid)
			{
				if(meta.oid.pre)
				{
					add$1(parts, meta.oid.pre);
				}
				if(meta.oid.value)
				{
					let node = this.child(meta.oid.value);
					if(node)
					{
						let value = node.value();
						if(!value)
						{
							this.logging.error('Child: Unset oid value', this.path());
							return null;
						}
						add$1(parts, value);
					}
				}
			}

			return parts.join('.');

		}


		
	};

	function add$1(parts, value)
	{
		value = String(value);
		if(value.indexOf('.') > -1)
		{
			Array.prototype.push.apply(parts, value.split('.'));
		} else {
			parts.push(value);
		}
	}


	var oid = mixin$6;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$7 = {
	     
	    /**
		 * @method guid Returns the guid.
		 * @returns {String} guid
		 */

		guid()
		{
			let meta = this.meta();
			if(meta && meta.guid)
			{
				return meta.guid;
			}
		},
		
		/**
		 * @method path Returns the path.
		 * @returns {String} path
		 */

		path()
		{
			if(this._root == this)
			{
				//root node
				return "";
			} else if(this._parent == this._root)
			{
				//first level child of root
				return this._name;
			} else {
				//nested node
				return this._parent.path() + '/' + this._name;
			}
	    },
	    
	    /**
		 * @method children Returns the children.
		 * @returns {K4.Child[]} Map of children
		 */

		children()
		{
			let obj = {};
			for(let i in this._children)
			{
				if(i != 'meta')
				{
					obj[i] = this._children[i];
				}
			}
			return obj;
	    },
	    
	    /**
		 * @method type Returns the type.
		 * @returns {String} type
		 */

		type() 
		{

			let meta = this.meta();

			if(meta && meta.type)
			{
				return meta.type;
			}

			return typeof this._value;
		},

		/**
		 * @method cls Returns the class.
		 * @returns {String} cls
		 */

		cls() 
		{

			if(this == this._root)
			{
				return;
			}

			let meta = this.child('meta');
			
			if(meta)
			{
				let m = meta.value();
				if(m && m.cls)
				{
					return m.cls;
				} 
			}

			return this._parent.cls();
	    },
	    
	    /**
		 * @method root Returns the root.
		 * @returns {K4.Child} root
		 */

		root()
		{
			return this._root;
	    },
	    

	    /**
		 * @method name Returns the name.
		 * @return {String} name
		 */
		name()
		{
			return this._name;
	    },
	    

	    /**
		 * @method child Returns a nested child. Can be used on any node with a path relative to this node.
		 * @param {String} path The path of the child. ie. "child1/child2"
		 * @returns {K4.Child} child
		 */

		child(path) {

			if(!path)
			{
				return null;
			}

			if(path.indexOf('/') == 0)
			{
				path = path.substring(1);
			}

			let pArr = path.split("/");
			let loc = path.indexOf("/");

			if(path == '' && this == this._root)
			{
				return this;
			} else  if (loc == -1) {
				return this._children[path];
			} else {

				let first = path.substring(0, loc);
				path = path.substring(loc + 1);

				if(this._children[first])
				{
					return this._children[first].child(path);
				} else {
					return null;
				}

			}
		},

		/**
		 * @method partent Returns a nodes parent.
		 * @returns {K4.Child} child
		 */

		parent() {

			return this._parent;

		},


		/**
		 * @method meta Returns the meta object.
		 * @returns {Object} meta
		 */

		meta(relative){

			let meta = this.child('meta');

			if(meta)
			{
				let m = meta.value();

				if(relative)
				{
					//looking for child objects nested meta

					let obj = m;
					let paths = relative.split("/");

					for(let i=0; i < paths.length; i++)
					{
						let p = paths[i];
						if(obj[p])
						{
							obj = obj[p];
						} else {
							return null;
						}
					}

					return obj;

				} else {
					return m;
				}

			} else {

				//keep moving up until we find a meta
				relative = (!relative) ? this._name : this._name + "/" + relative;
				if(this._parent)
				{
					return this._parent.meta(relative);
				} else {
					return null;
				}

			}
		}

		
	};

	var refs = mixin$7;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$8 = {
	     
	    /**
		 * @method remove Removes a child. Can only be called on object types.
		 * @param {String} name The child to remove.
		 * @param {Function} [callback] Callback function.
		 * @param {String} callback.err Error encountered. null on success.
		 */

		remove(name, callback, suppress) {

	        let { promiseId, promise, done } = this.registerCallback(callback);

	        this.logging.debug('Child: Removing ' + name);


			
			if(typeof this._value != "object" || this._value == null)
			{
				return done('Only object nodes can have children');
			}

			if(this.child(name) == undefined)
			{
				return done('Node doesnt exist');
			}

			//from the api
	        this._socket.emit('message', {
	            type: 'remove',
	            path: this.path(),
	            name: name,
	            from: this.config.from,
				callback: {
					promiseId: promiseId,
					origin: this.config.from
				},
	        });

	        return promise;


	    },
	    
	    _remove(name, done, suppress)
	    {

	        this.logging.debug('Child: Removed ' + name);

	        //from the message queue

	        let path = this._children[name].path();
	        let guid = this._children[name].guid();

	        delete this._value[name];
	        delete this._children[name];

	        delete this._root.guids[guid];

	        //clean up groups

	        this.cleanupGroups(path, this._root.classes);
	        this.cleanupGroups(path, this._root.groups);
	        this.cleanupGroups(path, this._root.paths);

	        if(!suppress)
	        {
	            this._dispatch("value", [this.value(), this.path()]);
	        }


	        if(typeof done == 'function') { done(); }
	    }

		
	};

	var remove = mixin$8;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$9 = {
		 
	    /**
		 * @method rename Sets the name.
		 * @param {String} name The name.
		 * @param {Function} [callback] Callback function.
		 * @param {String} callback.err Error encountered. null on success.
		 */

		rename(name, callback)
		{
			let { promiseId, promise, done } = this.registerCallback(callback);

			this.logging.debug('Child: Renaming ' + this._name + " to " + name);

			if(this._root == this)
	        {
	            return done('Cannot rename root');
	        }
			
			//from the api
			this._socket.emit('message', {
				type: 'rename',
				path: this.path(),
				name: name,
				from: this.config.from,
				callback: {
					promiseId: promiseId,
					origin: this.config.from
				}
			});

			return promise;

		},

		_rename(name, done) {
			
			this.logging.debug('Child: Renamed ' + this._name + " to " + name);
			
			//from the message queue

			//get the value of the node
			let temp = {};
			temp[name] = this.value(true);

			//remove it from the parent
			this._parent._remove(this._name);

			//reimport it
			this._parent.import(temp);

			if(typeof done == 'function') { done(); }
		}
		
	};

	var rename = mixin$9;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$a = {
		 
	    /**
		 * @method upgrade Upgrade a child. Can only be called on object types.
		 * @param {String} json The description json.
		 * @param {String} name The child to upgrade.
		 * @param {Function} [callback] Callback function.
		 * @param {String} callback.err Error encountered. null on success.
		 */



		upgrade(json, name, callback)
		{
			let { promiseId, promise, done } = this.registerCallback(callback);

			let node = this.child(name);
			
			if(!node)
			{
				return done("Invalid child name");
			}

			let meta = this.child('meta'); //dont use recursive meta function

			if(!meta)
			{
				return done('Only children with meta can be upgraded');
			}

			this.logging.debug('Child: Upgrading ' + name);

			//from the api
			this._socket.emit('message', {
				type: 'upgrade',
				path: this.path(),
				name: name,
				json: json,
				from: this.config.from,
				callback: {
					promiseId: promiseId,
					origin: this.config.from
				},
			});

			return promise;
		},

		_upgrade(json, name, done)
		{

			this.logging.debug('Child: Upgraded ' + name);

			let description;

			try {
				description = JSON.parse(json);
			} catch(e) {
				return done('Invalid description json');
			}

			let node = this.child(name);

			//get the value of the node - dont need meta
			let values = node.value();

			//remove it
			this._remove(name);

			//reimport it

			let temp = {};
			temp[name] = description;

			this.import(temp);

			//restore old values

			let restore = (values, node) => {
				
				let children = node.children();
				
				for(let i in children)
				{
					let child = children[i];

					let type = child.type();

					if(type == 'object' && values[child.name()])
					{
						//recursive call
						restore(values[child.name()], child);
					} else if(type == 'function') {
						continue;
					} else {

						let value = values[child.name()];
						if(typeof value != 'undefined')
						{
							child._set(value, null, true, true);
						}
					}

				}
			};

			restore(values, this.child(name));

			if(typeof done == 'function') { done(); }
		}
		
	};

	var upgrade = mixin$a;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$b = {
		 

		createGroups()
		{
			//create the groups this exist on the root node only

			this._children = {};

			this.guids = {};
			this.classes = {};
			this.paths = {
				variable: [],
				event: [],
				command: []
			};
			this.groups = {};
			this.promises = {};
			this.promiseId = 0;
	    },


	    cleanupGroups(path, group)
		{
			for(let i in group)
			{
				let g = group[i];

				for(let j = g.length - 1; j >= 0; j--) {
					let obj = g[j];
				    if(obj.path().indexOf(path + '/') == 0) {
						//remove children
				       g.splice(j, 1);
					}
					if(obj.path() == path) {
						//remove actual node
						g.splice(j, 1);
					 }
				}
			}
		},

		log(path, args, from)
		{

			let node = this._root.child(path);


			if(node)
			{

				if(Array.isArray(from))
				{
					from = from[0]; //first id should be origin
				}

				let data = {
					path: node.path(),
					value: node.value(),
					type: node.type(),
					cls: node.cls(),
					from: from
				};

				let oid = node.oid();

				if(oid)
				{
					data.oid = oid;
				}


				if(args)
				{
					data.value = args;
				}

				this.fireEvent("log", [data]);

			} else {
				this.logging.error('Child: Log: node not found.');
			}

		},


		clone(obj, meta) {

			if (obj == null || typeof (obj) != 'object')
			{
				return obj;
			}

			let temp = obj.constructor();

			for (let key in obj)
			{
				if(!meta && key == 'meta')
				{
					continue;
				}
				temp[key] = this.clone(obj[key], meta);
			}

			return temp;
		},

		createPaths(paths, base)
		{
			for(let i=0; i < paths.length; i++)
			{
				let path = paths[i];
				if(!this._root.paths[path])
				{
					this._root.paths[path] = [];
				}
				this._root.paths[path].push(base);
			}
		},

		registerCallback(callback)
		{
			let promise = this.defer(callback);
			
			this._root.promiseId++;

			let id = this._root.promiseId;

			this._root.promises[id] = promise;
			
			return {
				promiseId: id,
				promise: promise,
				done: (err, data) => {
					this.callCallback(id, err, data);
					return promise;
				},
				cancel: () => {
					delete this._root.promises[id];
				}
			}
		},

		defer(callback) {
			
			var _resolve, _reject, _callback;

			_callback = callback;
		
			var promise = new Promise((resolve, reject) => {
				_resolve = resolve;
				_reject = reject;
			});
		
			promise.resolve = (data) => {
				if(typeof callback == 'function')
				{
					_callback(null, data);
				} else {
					_resolve(data);
				}
			};
			promise.reject = (err) => {
				if(typeof callback == 'function')
				{
					_callback(err);
				} else {
					_reject(err);
				}
			};	
			return promise;
		},

		checkCallback(callback, err, data)
		{
			if(callback)
			{
				if(typeof callback.origin == 'string' && callback.origin == this.config.from)
				{
					this.callCallback(callback.promiseId, err, data);
				} 
			}
		},

		callCallback(promiseId, err, data)
		{
			let promise = this._root.promises[promiseId];

			if(typeof promise == 'object')
			{

				if(err)
				{
					promise.reject(err);
				} else {
					
					promise.resolve(data);
				}

				delete this._root.promises[promiseId];
			}
		}


	    
	};

	var util$1 = mixin$b;

	var isNode$2 = (typeof process !== 'undefined' && process.versions && process.versions.node);

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */

	 const mixin$c = {
		 
	    /**
		 * @method set Sets the value. Cannot be called on object types.
		 * @param {String/Boolean/Number/null} value The value.
		 * @param {Function} [callback] Callback function.
		 * @param {String} callback.err Error encountered. null on success.
		 */

		set(value, callback, suppress, skipUpdate, from) {


			let { promiseId, promise, done } = this.registerCallback(callback);

			// check v for string, bool, number - in future, check against meta
			let vType = typeof value;

			if ( vType !== 'string' && vType !== 'boolean' && vType !== 'number' && value !== null) {
				//ignore duplicate changes
				return done('value must be a string, number, boolean or null');
			}


			if(value === this._value)
			{
				//ignore duplicate changes
				return done();

			}

			if(typeof this._value == "object" && this._value != null && !Array.isArray(this._value))
			{
				return done('Cannot set object nodes');

			} else {

				//from the api
	            this._socket.emit('message', {
	                type: 'set',
	                path: this.path(),
	                value: value,
	                from: this.config.from,
	                callback: {
						promiseId: promiseId,
						origin: this.config.from
					},
	            });


			}

			return promise;
	    },
	    
	    _set(value, done, suppress, skipUpdate, from)
	    {
	        //from the message queue
	        this._value = value;

	        if(!skipUpdate)
	        {
	            let update = {};
	            update[this._name] = value;

	            //use update to update the parent object, this is a leaf node - skip the set
	            this._parent._update(update, null, true);
	        }


	        if(!suppress)
	        {
	            this.logging.debug('Child: Set ' + this.path(), value);
	            //send to any value handlers on this node
	            this._dispatch("value", [this.value(), this.path()]);

	            //send log event up the chain

	            this.log(this.path(), null, from);

			}
			
	        if(typeof done == 'function') { done(); }
	    },


	    /**
		 * @method update Updates multiple values. Can only be called on object types.
		 * @param {Object.<String/Boolean/Number>} value Object of key / value pairs to update. Values must be String/Boolean/Number.
		 * @param {Function} [callback] Callback function.
		 * @param {String} callback.err Error encountered. null on success.
		 */

		update(obj, callback, skipSet)
		{
			let { promiseId, promise, done } = this.registerCallback(callback);

			//debug('update: ', obj);
			if(typeof this._value == "object" && this._value != null && !Array.isArray(this._value))
			{
				if(typeof obj == "object")
				{
					//from the api
	                this._socket.emit('message', {
	                    type: 'update',
	                    path: this.path(),
	                    value: obj,
	                    from: this.config.from,
	                    callback: {
							promiseId: promiseId,
							origin: this.config.from
						},
	                });

				} else {
					return done('Argument must be object of key value pairs');
				}
			} else {
				return done('Only object nodes can be updated');
			}

			return promise;
	    },
	    
	    _update(obj, done, skipSet, from)
	    {
	        //from the message queue
	        for(let i in obj)
	        {
	            let child = this.child(i);
	            if(child)
	            {
					this._value[i] = obj[i];
					if(!skipSet)
					{
						//update the childs local value
						child._set(obj[i], null, false, true, from); //skip update so there is no loop
					}
	                
	            }
	        }


	        if(typeof done == 'function') { done(); }
	    },


	    /**
		 * @method value Returns a snapshot of the current value.
		 * @returns {Object/String/Boolean/Number} value
		 */

		value(meta) {

			if(typeof this._value == 'object' && this._value != null && !Array.isArray(this._value))
			{
				return this.clone(this._value, meta);
			} if(this.type() == 'secure' && isNode$2) {
				return secure.decrypt( this.config.system, this, this._value);
			} else {
				return this._value;
			}

		}
		
	};

	var value = mixin$c;

	/**
	 * @class K4.Child
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#model}.
	 */


	/**
	 * @method Child
	 * Creates a new Child object
	 * @param {String} name The child name.
	 * @param {Object/String/Boolean/Number} value The initial value.
	 * @param {K4.Child} parent The parent object.
	 * @param {K4.Server/K4.Client} this._socket The owner of the model.
	 * @return {K4.Child}
	 */


	class Child$1 {

		constructor(name, value, parent, socket)
		{
			this._value = value;
			this._name = name;
			this._parent = parent;
			this._socket = socket;

			this._children = {};

			this.logging = socket.parent.logging;
			this.config = socket.parent.config;

			//if we have a parent, we are not the root node
			if(parent)
			{
				this._root = parent.root();
			} else {
				this._root = this;
				this._events = {};
				this.createGroups();
			}
		}
		
	}

	//mixins

	Object.assign(Child$1.prototype, add);
	Object.assign(Child$1.prototype, construct);
	Object.assign(Child$1.prototype, events$1);
	Object.assign(Child$1.prototype, execute);
	Object.assign(Child$1.prototype, message);
	Object.assign(Child$1.prototype, move);
	Object.assign(Child$1.prototype, oid);
	Object.assign(Child$1.prototype, refs);
	Object.assign(Child$1.prototype, remove);
	Object.assign(Child$1.prototype, rename);
	Object.assign(Child$1.prototype, upgrade);
	Object.assign(Child$1.prototype, util$1);
	Object.assign(Child$1.prototype, value);


	var child = Child$1;

	if(typeof commonjsGlobal == 'object')
	{
		commonjsGlobal.Child = Child$1;
	}

	const { isNode: isNode$3, isCloud: isCloud$2 } = helper;


	//node.js specific init code

	var node = {

		init(that)
		{
			let config = that.config;
			let util = that.util;

		
			if(!isNode$3)
			{
				console.log('Node init helper was called from something other than node');
				process.exit(1);
			}


			that.Child = child;


			if(typeof commonjsGlobal.gc == 'function')
			{
				setInterval(function () {
					commonjsGlobal.gc();
				}, 30000);
			}

			//not the cloud, so we should have mac and logging
			if ( !isCloud$2 ) {
						
				try {
					if (process.env['K4MAC']) {
						config.mac = process.env['K4MAC'];
					} else {
						throw new Error('MAC Address environment variable does not exist or was not specified');
					}
				} catch ( err ) {
					console.log("Could not determine system MAC address. ", err);
				}

				that.logging = require$$2;
		
			} else {
				that.logging = {
					logLevel: 3,
					debug: function() {
						if(that.logging.logLevel > 4)
						{
							console.log.apply(console, arguments);
						}
					},
					info: function() {
						if(that.logging.logLevel > 3)
						{
							console.log.apply(console, arguments);
						}
					},
					system: function() {
						if(that.logging.logLevel > 2)
						{
							console.log.apply(console, arguments);
						}
					},
					warning: function() {
						if(that.logging.logLevel > 1)
						{
							console.log.apply(console, arguments);
						}
					},
					error: function() {
						if(that.logging.logLevel > 0)
						{
							console.log.apply(console, arguments);
						}
					},
					fatal: function() {
						console.log.apply(console, arguments);
					}
				};
			}

			//computer the url from mac address
			if(config.url == 'auto')
			{
				if(config.mac)
				{
					config.url = "https://k4-controller-" + config.mac.toLowerCase().replace(/:/g, '') + ".local:8000";
				} else {
					console.log('Could not auto set url');
					process.exit(1);
				}

			}

			//we are not cloud, not server, but bridge so we need a token to use with message server
			if(!config.ctoken && !config.cloud)
			{

				var token = util.getConfig('token');

				if(!token)
				{
					config.newToken = true;
					token = util.guid();
				}

				config.token = token;

			}

			//not the cloud, but anything other than loader server
			if(!config.cloud && config.from != 'loader')
			{

				if(!config.system)
				{
					if (process.env['SYSTEMID']) {
						var systemId = process.env.SYSTEMID;
					}

					if(systemId && systemId.length == 36)
					{
						config.system = systemId;
					}
				}

				//from is passed in as 4th argument to bootstrap

				if (process.env['K4SERVICEGUID'] && process.env['K4SERVICEGUID'].length === 36) {
					config.from = process.env['K4SERVICEGUID'];
				} else if(process.argv[4] && process.argv[4].length === 36)
				{
					config.from = process.argv[4];
				} else {
					console.log('Required from argument missing.');
					process.exit();
				}

			}
		}
	};

	const { isNode: isNode$4, isCloud: isCloud$3 } = helper;


	//browser specific init code

	var browser = {
		init(that)
		{

		
			if(isNode$4 && !that.config.browser)
			{
				console.log('Browser init helper was called from node');
				process.exit(1);
			}

			//setup browser logging

			that.logging = {
				logLevel: 3,
				debug: function() {
					if(that.logging.logLevel > 4)
					{
						console.log.apply(console, arguments);
					}
				},
				info: function() {
					if(that.logging.logLevel > 3)
					{
						console.log.apply(console, arguments);
					}
				},
				system: function() {
					if(that.logging.logLevel > 2)
					{
						console.log.apply(console, arguments);
					}
				},
				warning: function() {
					if(that.logging.logLevel > 1)
					{
						console.log.apply(console, arguments);
					}
				},
				error: function() {
					if(that.logging.logLevel > 0)
					{
						console.log.apply(console, arguments);
					}
				},
				fatal: function() {
					console.log.apply(console, arguments);
				}
			};
		}
	};

	const { isNode: isNode$5, isCloud: isCloud$4 } = helper;

	const mixin$d = {

		//create shortcuts on ready

		updateServerDevice()
		{
			//if a from guid was specified, set a shortcut to the device in server

			this.logging.debug("Setting device.");

			if(this.model && this.config.from)
			{
				let node = this.model.guids[this.config.from];
				if(node)
				{
					this.logging.debug("Set device");
					this.device = node;

				}
			}

			this.logging.debug("Setting controller.");

			if(isNode$5 && !this.config.browser && this.model)
			{
				if ( this.device ) {
					//fire server started
					this.device.child('events/started').fire();
				}

				if(this.config.mac && this.model.groups.controllers)
				{
					for(let i = 0; i < this.model.groups.controllers.length; i++)
					{
						let node = this.model.groups.controllers[i];
						if(node.child('properties/mac').value().toLowerCase().replace(/:/g, '') == this.config.mac.toLowerCase().replace(/:/g, ''))
						{
							this.logging.debug("Controller found.", node.guid());
							this.controller = node;
							return;
						}
					}
				}


			}

			this.controller = null;

		}

	};

	var ready = mixin$d;

	const { isNode: isNode$6, isCloud: isCloud$5 } = helper;





	//node.js specific init code

	var node$1 = {

		init(that)
		{
		
			if(!isNode$6 )
			{
				console.log('Node init helper was called from something other than node');
				process.exit(1);
			}

			if(!isCloud$5)
			{
				const LocalStorage = require$$2.LocalStorage;
				if (process.env['LOCALSTORAGEPATH']) {
					that.localStorage = new LocalStorage(process.env['LOCALSTORAGEPATH']);
				} else {
					that.localStorage = new LocalStorage(__dirname + '/local-storage');
				}

				that.messageBuffer = require$$2;
				that.messageBuffer.initialize(process.env['LOCALSTORAGEPATH'], (err) => {
					if (err) {
						console.log('Error loading message buffer: ', err);
					} else {
						console.log('Loaded message buffer.');
					}
				});
			}

			this.client(that, that.config.url + "/" + that.config.system);

		},

		client(that, url)
		{
			that.client = socket(url, {
				query: that.query,
				transports: ['websocket'],
				autoConnect: false,
				forceNew: true
			});
		}
	};

	const { isNode: isNode$7, isCloud: isCloud$6 } = helper;



	//browser specific init code

	var browser$1 = {
		init(that)
		{

			if(isNode$7 && !that.config.browser)
			{
				console.log('Browser init helper was called from node');
				process.exit(1);
			}

			
			this.client(that, that.config.url + "/" + that.config.system);

		},

		client(that, url)
		{
			that.client = socket(url, {
				query: that.query,
				transports: ['websocket'],
				autoConnect: false,
				forceNew: true
			});
		}
	};

	const { isNode: isNode$8, isCloud: isCloud$7 } = helper;


	var connection = {
		
		connect()
		{
			this.connected = true;
			this.logging.system('Client: Connected');

			this.parent.dispatch('connected');

			if ( isNode$8 && !this.config.browser && this.config.url && this.config.url.indexOf('k4connect.com') > -1 ) {
				try {
					this.localStorage.setItem('sessionId', this.client.id);
				} catch (err) {
					this.logging.system('Client: Unable to write sessionId');
				}
			}


			if(this.config.server)
			{

				//if we are a server, send to data to other servers - initiator is always master
				this.client.emit('message', {
					type: 'initial',
					path: null,
					value: this.model.value(true),
					from: this.config.from
				});

			} else {

				//if we are client, request the initial
				this.client.emit('message', {
					type: 'refresh',
					path: null,
					value: null,
					from: this.config.from
				});

			}

			if(isNode$8 && !this.config.browser)
			{

				if(this.config.newToken)
				{
					this.parent.util.setConfig('token', this.config.token);
				}

				// send buffered messages until there aren't any left
				this.messageBuffer.shiftMessage( processMessage = (err, name, data) => {
					if ( err ) {
						this.logging.error('Client: Could not retrieve buffered message', err);
					} else {
						if ( name !== null && data !== null && this.client && this.client.connected ) {
							this.logging.debug('Client: Send from buffer.', data);
							this.client.emit(name, data);

							setTimeout(() => {
								this.messageBuffer.shiftMessage(processMessage);
							}, 500);
						}
					}
				});
			}

		},

		disconnect()
		{

			if(!this.connected)
			{
				//prevent duplicate timers
				return;
			}

			this.connected = false;
			this.parent.dispatch('disconnected');
			this.logging.system('Client: Disconnected');

			if ( isNode$8 && !this.config.browser ) {
				
				if ( this.reconnectTimer ) {
					clearTimeout(this.reconnectTimer);
				}

				this.reconnectTimer = setTimeout(() => {
					if ( !this.connected ) {
						this.logging.system('Client: Reconnect timer reconnecting');
						this.client.connect();
					} else {
						clearTimeout(this.reconnectTimer);
					}
				}, 60000);
			}
		},

	};

	/**
	 * @class K4.Client
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#client}.
	 */

	var events$2 = {
		
		/**
		 * @method emit Emits a message to the client.
		 * @param {String} name The message name. Usually "message".
		 * @param {Object} data The data to emit.
		 * @param {String} data.type The type of message (set, update, etc).
		 * @param {String} data.path The path of the model node.
		 * @param {Object} data.value The value specific to the message type.
		 * @param {String} data.from The unique id of the sender.
		 */

		emit(name, data)
		{
			if(this.connected)
			{
				this.client.emit(name, data);
			}

		}
	};

	/**
	 * @class K4.Client
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#client}.
	 */

	var messages = {
		
		//process incoming messages
		message(data)
		{
			this.logging.debug('Client: Message',  data);
		
			if(this.config.server)
			{
				let ours = false;

				//dont send back to server if it came from server
				if(Array.isArray(data.from))
				{
					for(let i=0; i < data.from.length; i++)
					{
						let from = data.from[i];
						if(from == this.config.from)
						{
							ours = true;
							break;
						}
					}
				} else {
					ours = (data.from == this.config.from);
				}

				if(!ours)
				{
					this.parent.server.emit('message', this.config.system, data, true);
				}

			} else {
				this.model.message(data);
			}

		},

		/**
		 * @method enqueue Queue commands to be send after reconnect.
		 * @param {String} name The message name. Usually "message".
		 * @param {Object} data The data to queue.
		 */

		enqueue(name, data)
		{
			this.messageBuffer.bufferMessage(name, data);

		},

		forceDisconnect(){
			this.client.disconnect();
		},

		/**
		 * @method getQueueCount Retrieves the current number of events in the queue
		 */

		 getQueueCount(cb) {
		 	this.messageBuffer.countMessages(cb);
		 }
	};

	//browser specific init code

	var query = {

		buildQuery()
		{
		
			if(this.config.token)
			{
				//bridge
				this.query = 'system=' + this.config.system + '&token=' + this.config.token;
			} else {
				//client or upstream connection
				this.query = 'system=' + this.config.system + '&ctoken=' + this.config.ctoken + '&from=' + this.config.from + '&username=' + this.config.username +  '&password=' + this.config.password;
			}

			if(this.config.analytics)
			{
				this.query += '&analytics=' + this.config.analytics;
			}

			if(this.config.btoken)
			{
				this.query += '&btoken=' + this.config.btoken;
			}

			if(this.config.from)
			{
				this.query += '&from=' + this.config.from;
			}

		}
	};

	const { isNode: isNode$9, isCloud: isCloud$8 } = helper;

	var run = {

		run()
		{
			this.io = this.client;
			
			this.client.on('error', (err) => {
				if ( this.config.server ) {
					this.logging.error("Client: Error:", err);
				} else {

					if(typeof err == 'object' && err.redirect)
					{
						
						//redirect to another node
						this.client.disconnect();
						let url = err.redirect;

						this.logging.system("Redirecting to: ", url);

						if( isNode$9 && !this.config.browser )
						{
							let node = node$1;
							node.client(this, url);
						} else {
							let browser = browser$1;
							browser.client(this, url);
						}

						this.run();

					} else {
						this.logging.fatal("Client: Error:", err);
						this.parent.dispatch('error', [err]);
					}				
				}
			});
		
			this.client.on('connect', () => {
				this.connect();
			});
		
			this.client.on('disconnect', () => {
				this.disconnect();
			});

			this.client.on('reconnect', (attempt)=> {
				this.logging.system(`Client: Re-connected on attempt ${attempt}`);
			});
		
			this.client.on('connect_error', (err) => {
				this.logging.debug("Client: Could not connect, error", err);
				if(this.parent.clientDisconnectCallback){
					this.parent.clientDisconnectCallback(err);
				}
			});

			this.client.on('message', (data) => {
				this.message(data);
			});

			this.client.on('pong', (ms) => {
				if( isNode$9 && !this.config.browser )
				{
					//kick watchdog timer on node clients
					this.parent.watchdog.kick();
				}
			});

			this.client.io.on('close', ()=>{

				//TODO: remove after upgrade of socket.io to 4.x. This is a temporary fix for close events not always making it to Socket layer from io
				this.disconnect();
				
			});

			this.logging.system('Client: Connecting...', this.config.url, this.config.system, this.config.from, this.config.demo);
			
			this.client.open();


		}

	};

	const { isNode: isNode$a, isCloud: isCloud$9 } = helper;


	/**
	 * @class K4.Client
	 *
	 * <b>Note:</b> This class should not be used directly. It is created by the base {@link K4} class and is available as {@link K4#client}.
	 */



	/**
	 * @method Client
	 * Creates a new Client object
	 * @param {K4} parent The base K4 object.
	 * @return {K4.Client}
	 */

	 class Client {

		constructor(parent)
		{
			this.parent = parent;
			this.config = parent.config;
			this.logging = parent.logging;

			this.connected = false;

			//queue helper

			this.buildQuery();

			//platform specific setup
			if( isNode$a && !this.config.browser)
			{
				let node = node$1;
				node.init(this);
			} else {
				let browser = browser$1;
				browser.init(this);
			}

			if(this.config.server)
			{
				this.model = this.parent.server.model(this.config.system);

			} else {

				//client mode - create model
				this.model = new child("System", {}, null, this);
				this.parent.model = this.model;

			}


			this.run();
			
			
		}
	 }

	 //mixins
	Object.assign(Client.prototype, connection);
	Object.assign(Client.prototype, events$2);
	Object.assign(Client.prototype, messages);
	Object.assign(Client.prototype, query);
	Object.assign(Client.prototype, run);

	var client = Client;

	var auth = {
		
		//make sure the connection is allowed to use this namespace

		authenticateNS(socket, next)
		{
			let system = socket.request._query.system;
			let user = socket.request._query.user;
			let password = socket.request._query.password;
			socket.request._query.session = socket.id;

			let model = this.models[system];

			if ( !model && !this.config.controllerless) {
				return next(new Error('no controller'));
			}

			this.config.authenticate(socket.request._query, model, (err, authenticated) => {
				if ( !authenticated ) {
					next(new Error('not authorized'));
				} else {

					if(typeof authenticated == 'object')
					{
						//save the returned user
						socket.request.user = authenticated;
					}

					//make sure model has analytics
					if(socket.request._query.analytics)
					{
						model.analytics = socket.request._query.analytics;
					}

					// FIXME: doesn't handle daisychained clouds
					if ( socket.request._query.btoken ) {
						this.downstreams[socket.request._query.system] = socket;
					}

					let data = {
						type: 'connect',
						value: 'connected',
						from: socket.request._query.from
					};

					if ( socket.request._query.btoken ) {
						data.oid = '1.3.6.1.4.1.32473.1.2';
					}

					let success = this.modelLog(model, data);

					if ( !success ) {
						socket.request._query.delayConnectEvent = true;
					}

					next(null);
				}
			});
		}
	};

	var connection$1 = {
		
		//handle a new connection to the namespace
		connection(socket)
		{
			let system = socket.request._query.system;
			let from = socket.request._query.from;

			this.logging.system("Server: Connected ", socket.id, system, from);

			this.sockets[system][socket.id] = socket;

			if ( from ) {
				if ( !this.from[system] ) {
					this.logging.system("Server: missing system ", system, from);
					socket.client.disconnect(true);
					return;
				}
				this.from[system][from] = socket;
			}

			socket.on('disconnect', () => {
				this.disconnect(socket);
			});

			socket.on('message', (data) => {
				this.message(socket, data);
			});
			socket.on('log', (data) => {
				this.log(data);
			});

			socket.on('error', (err) => {
				console.log(err);
			});
		},

		//clean up on disconnect

		disconnect(socket)
		{

			let system = socket.request._query.system;
			let from = socket.request._query.from;

			this.logging.system("Server: Disconnect ", socket.id, system, from);

			delete this.sockets[system][socket.id];

			let reconnected = false;

			if ( socket.request._query.btoken ) {
				for ( let socketId in this.sockets[system] ) {
					let s = this.sockets[system][socketId];
					// the box has already reconnected on a different socket
					if ( s !== socket && s.request._query.btoken ) {
						reconnected = true;
						break;
					}
				}
			}

			let model = this.models[system];

			if ( !reconnected && socket.request._query.btoken ) {
				for ( let socketId in this.sockets[system] ) {
					this.sockets[system][socketId].disconnect(true);
				}
			}

			if( socket.request._query.btoken || (Object.keys(this.sockets[system]).length == 0 && !this.config.server))
			{
				//last socket - clean up model and nsp
				this.logging.debug('Server: Clean up system', system);
				delete this.io.nsps["/" + system];
				delete this.systems[system];
				delete this.models[system];
				delete this.from[system];
			}

			let data = {
				from: from
			};

			if ( !reconnected ) {
				data.type = 'disconnect';
				data.value = 'disconnected';
			} else {
				data.type = 'disconnectAfterReconnect';
				data.value = 'disconnectedAfterReconnect';
			}

			if ( socket.request._query.btoken ) {
				data.oid = '1.3.6.1.4.1.32473.1.2';
			}

			this.modelLog(model, data);

		},

		//if the namespace doesnt exist, create it

		provisionNS(system, analytics)
		{
			
			if(!this.systems[system] && analytics)
			{
				this.logging.debug('Server: Provision ns', system);

				let nsp = this.io.of("/" + system);

				nsp.use((socket, next) => {
					this.authenticateNS(socket, next);
				});
				nsp.on('connection', (socket) => {
					this.connection(socket);
				});

				this.systems[system] = nsp;
				this.sockets[system] = {};
				this.from[system] = {};

				nsp.parent = this.parent;

				
				let model = new Child("System", {}, null, {

					//emulate the normal socket object, but with system passed in to handle multitenancy
					emit: (name, data) => {
						this.emit(name, system, data);
					},
					parent: {
						config: {
							from: this.config.from,
							system: system
						},
						logging: this.logging,
						util: this.parent.util,
						dispatch: (event, args) => {
							this.parent.dispatch(event, args);
						}
					}
				});

				this.models[system] = model;
				model.system = system;
				model.analytics = analytics;

				model.on('log', (data) => {
					this.modelLog(model, data);
				});

				this.parent.dispatch('load', [ this.parent, model, (json) => {
					//if a load event returns, import it into the model
					if(json)
					{
						model.import(json);

						//must happen in next tick because the constructer isnt finished yet
						setTimeout(() => {
							this.parent.dispatch('ready', [ model ]);
						}, 500);

					}

				}]);

			} else {
				if ( analytics ) {
					this.logging.system('Server: Namespace already provisioned for', system);
				} else {
					this.logging.system('Server: Attempt to connect to invalid namespace', system);
				}
			}
		}
	};

	var events$3 = {
		
		/**
		 * @method emit Emits a message to clients.
		 * @param {String} name The message name. Usually "message".
		 * @param {String} system The system id to emit to.
		 * @param {Object} data The data to emit.
		 * @param {String} data.type The type of message (set, update, etc).
		 * @param {String} data.path The path of the model node.
		 * @param {Object} data.value The value specific to the message type.
		 * @param {String} data.from The unique id of the sender.
		 */

		emit(name, system, data, fromClient, local)
		{
			this.logging.debug('Server: Emit',  data);

			let model = this.models[system];
			let nsp = this.systems[system];

			if(!model || !nsp)
			{
				this.logging.error('Server: Emit to unprovisioned namespace',  system);
				return;
			}


			if ( typeof data.from === 'string' ) {
				data.from = [ data.from ];
			}

			// add ourselves to the from list so replies tunnel back
			if ( data.from.indexOf(this.config.from) === -1 ) {
				data.from.push(this.config.from);
			}

			if(data.type == 'execute' || data.type == 'reply')
			{


				//for us, send to model
				if(data.receiver == this.config.from)
				{
					model.message(data);
				} else {
					let downstream = this.downstreams[system];
					if ( downstream ) {
						downstream.emit(name, data);
					}

					if ( Array.isArray(data.receiver) ) {
						// send to anyone in the receiver list that is connected to us
						for ( let i = 0 ; i < data.receiver.length ; i++ ) {
							let t = data.receiver[i];

							if ( t === this.config.from ) {
								model.message(data);
							} else {
								let s = this.from[system][t];
								if ( s && s !== downstream ) {
									s.emit(name, data);
								}
							}
						}
					} else {
						let s = this.from[system][data.receiver];
						if ( s && s !== downstream ) {
							s.emit(name, data);
						}
					}
				}

				if(data.type == 'execute')
				{
					model.log(data.data.path, data.data.args, data.from);
				}


			} else {

				//update local model
				model.message(data);

				//send to nsp
				nsp.emit(name, data);
			}

			//forward to client if exists and this didnt come from client
			if(this.parent.client && !fromClient)
			{
				this.parent.client.emit(name, data);
			}


		}
	};

	var logging = {
		
		//process incoming log from downstream servers
		log(data)
		{
			this.parent.dispatch('log', [data]);

			if(this.parent.client)
			{
				this.parent.client.emit("log", data);
			}
		},

		//dispatch log events on model
		modelLog(model, data) {

			if ( model && model.groups && model.groups.controllers && model.groups.controllers.length > 0 ) {
				let controller = model.groups.controllers[0];
				let clock = controller.child('variables/clock');

				let path = clock.path();

				if(data.path == path + "/date" || data.path == path + "/time" || data.path == path + "/day")
				{
					let time = clock.value();
					time.updated = Date.now();
					this.timestampMap[model.system] = time;
					return;
				}

				let time = this.timestampMap[model.system];
				let date;

				if ( typeof time === 'undefined' || typeof time.date !== 'string' || typeof time.time !== 'string' ) {
					// haven't received time/date update yet, rely on server seconds
					time = clock.value();
					let local = new Date();
					date = new Date(time.date + " " + time.time);

					if ( local.getTimezoneOffset() === 0 ) {
						date = new Date(date.getTime() + time.offset*60*1000);
					}

					if ( local.getMinutes() > date.getMinutes() ) {
						date.setMilliseconds(59000);
					} else if ( local.getMinutes() < date.getMinutes() ) {
						date.setMilliseconds(0);
					} else {
						date.setSeconds(local.getSeconds(), local.getMilliseconds());
					}

				} else {
					// use stored time object
					let local = new Date();
					date = new Date(time.date + " " + time.time);

					if ( local.getTimezoneOffset() === 0 ) {
						date = new Date(date.getTime() + time.offset*60*1000);
					}

					// calculate seconds based on delta of updated timestamp
					let ms = Date.now() - time.updated;
					date.setMilliseconds(ms);
				}

				data.timestamp = date.getTime();
				data.tzoffset = time.offset;
				data.analyticsId = model.analytics;
				data.systemId = model.system;

				//dispatch to handler
				this.parent.dispatch('log', [data]);

				//upstream server would not have seen this event, cache it
				if(this.config.url && !this.parent.client.connected)
				{
					//client was disconnected - queue logs
					this.parent.client.enqueue("log", data);
				} else if ( this.config.url && (data.type === 'connect' || data.type === 'disconnect') ) {
					this.parent.client.emit("log", data);
				}

				return true;
			} else {
				this.logging.error('Server: No controller found.');
			}

		}
	};

	var messages$1 = {
		
		//process incoming messages
		message(socket, data)
		{
			let system = socket.request._query.system;

			let model = this.models[system];

			if(data.type == 'set')
			{
				var node = model.child(data.path);

				if(node && node.type() == 'password' && typeof this.config.hash == 'function')
				{
					data.value = this.config.hash(data.value);
				}

				if(node && node.type() == 'secure')
				{
					data.value = this.secure.encrypt(system, node, data.value);
				}

			}

			if(data.type == 'refresh')
			{
				//a remote client just asked for a model refresh - send it to them only
				let remote = this.from[system][data.from];
				this.logging.debug('Server: Refresh, sending initial', remote.id);
				remote.emit('message', {
					type: 'initial',
					path: null,
					value: model.value(true),
					from: this.config.from
				});

			} else if(this.config.cloud && data.data && data.data.path && data.data.path.indexOf('Cloud') === 0) {
				this.parent.dispatch('cloud', [ socket, data ]);
			} else {
				//emit all other messages into the systems namespace
				this.emit('message', system, data);
			}

		}
	};

	var run$1 = {
		
		run()
		{
			let app;
			if ( this.config.key && this.config.cert ) {
				
				let options = {
					key : this.config.key,
					cert : this.config.cert
				};

				app = require$$2.createServer(options);
			} else {
				app = require$$2.createServer();
			}

			let io = require$$2(app, {
				serveClient: false,
				transports: ['websocket']
			});

			this.io = io;
			this.app = app;

			app.listen(this.port);



			this.logging.system("Server: Listening on port ", this.port);

			if(this.config.system && this.config.analytics)
			{
				this.logging.system("Server: Provision local system ", this.config.system);
				//go ahead and provision the local ns
				this.provisionNS(this.config.system, this.config.analytics);
				this.parent.model = this.models[this.config.system];
			} else {
				this.logging.system("Server: System and analytics not provided. No local system provisioned.");
			}


			//handle initial connections - make sure they are namespaced
			this.io.use((socket, next) => {

				let error;

				if(!socket.request._query || !socket.request._query.system)
				{
					error = new Error("invalid namespace");
					this.logging.system("Server: Invalid namespace");
				} else {


					let analytics = socket.request._query.analytics;
					let system = socket.request._query.system;

					//redirect clients that cant provision the ns if redirect is configured
					if(!this.systems[system] && !analytics && this.config.redirect)
					{
						socket.client.packet({ type: 4, nsp: `/${socket.request._query.system}`, data: {
							redirect: `${this.config.redirect}/controllerless/${socket.request._query.username}`
						}});
						return next();
					}

					//attempt to provision ns
					if(this.config.controllerless)
					{
						//force provisioning for controllerless (normally done by controller)
						let nsp = `controllerless/${socket.request._query.username}`;
						socket.request._query.system = nsp;
						this.provisionNS(nsp, true);
					} else {
						this.provisionNS(socket.request._query.system, socket.request._query.analytics);
					}
					
				}

				next(error);
			});
		}
	};

	var isNode$b = (typeof process !== 'undefined' && process.versions && process.versions.node);

	/**
	 * @method Server
	 * Creates a new Server object
	 * @param {K4} parent The base K4 object.
	 * @return {K4.Server}
	 */


	class Server {

		constructor(parent)
		{
			this.parent = parent;
			this.config = parent.config;
			this.logging = parent.logging;

			this.systems = {};
			this.models = {};
			this.sockets = {};
			this.from = {};
			this.downstreams = {};
			this.timestampMap = {};

			this.port = (parent.config.port) ? parent.config.port : 8000;

			this.run();
		}


		/**
		 * @method model Retrieves the model for a given system id. If {@link K4#cfg-system} is specified, the default model is available at {@link K4#model}.
		 * @param {String} system The system.
		 * @returns {K4.Child}
		 */

		model(system)
		{
			return this.models[system];
		}
	}

	//mixins
	Object.assign(Server.prototype, auth);
	Object.assign(Server.prototype, connection$1);
	Object.assign(Server.prototype, events$3);
	Object.assign(Server.prototype, logging);
	Object.assign(Server.prototype, messages$1);
	Object.assign(Server.prototype, run$1);


	var server = Server;

	const { isNode: isNode$c, isCloud: isCloud$a } = helper;


	let Server$1;

	if ( isNode$c ) {

		Server$1 = server;
		
	}

	const mixin$e = {

		//starts either a server, client, or both

		run()
		{
			let isRunning;

			let config = this.config;

			//server - it will host the model
			if(config.server === true && config.authenticate && isNode$c)
			{
				this.server = new Server$1(this);
				isRunning = true;
			}

			//client - if no server, it will get model from a server
			if(config.url || config.demo)
			{

				if(	(config.server && config.system && config.ctoken && config.analytics) //message server, client to cloud
					|| (!config.server && config.system && config.ctoken) //browser
					|| (config.system && config.token) ) //bridge
				{
					
					if(config.clientDisconnectCallback){
						this.clientDisconnectCallback = config.clientDisconnectCallback;
					}
					
					this.client = new client(this);
					isRunning = true;
				} else {
					this.logging.error("Missing credentials");
				}


			}

			if(!isRunning)
			{
				this.logging.error("No server or client setup. Check options.");
			}
		}

	};

	var run$2 = mixin$e;

	var src = createCommonjsModule(function (module) {
	const { isNode, isCloud } = helper;







	/**
	 * @class K4
	 * Base class of the SDK
	 */

	/**
	 * @cfg {String} url The url to create a client connection to.
	 */

	/**
	 * @cfg {String} system The system id.
	 */

	/**
	 * @cfg {String} ctoken The ctoken.
	 */

	/**
	 * @cfg {String} analytics The analytics id.
	 * @bridgeonly
	 */

	/**
	 * @cfg {String} from The guid of this device.
	 * @uionly
	 */

	/**
	 * @cfg {Boolean} server True to start a server.
	 * @bridgeonly
	 */

	/**
	 * @cfg {Boolean} demo True to use emulator.
	 */

	/**
	 * @cfg {Object} listeners Event listeners.
	 * @cfg {Function} listeners.ready Called when the model is ready.
	 * @cfg {Function} listeners.value Called when a model value changes.
	 * @cfg {Function} listeners.execute Called when a function node is executed.
	 * @cfg {Function} listeners.fire Called when an event node is fired.
	 * @cfg {Function} listeners.log Called when a node change is logged.
	 */

	/**
	 * @cfg {Function} authenticate Callback function to handle authentication. Return true or false to authenticate.
	 * @param {Object} handshake Handshake data.
	 * @param {String} handshake.system The system.
	 * @param {String} handshake.username The username.
	 * @param {String} handshake.password The password.
	 * @param {String} handshake.device The device.
	 * @bridgeonly
	 */

	/**
	 * @cfg {Function} hash Callback function to hash passwords. Returns string to be saved.
	 * @param {String} password Password to hash.
	 * @bridgeonly
	 */


	/**
	 * @property {K4.Child} model The current model. Only created if {@link K4#system} is defined.
	 */

	/**
	 * @property {K4.Child} device The instance device. Only created if {@link K4#from} is defined with a valid node guid.
	 */

	/**
	 * @property {K4.Child} controller The controller the bridge or server is running on.
	 * @bridgeonly
	 */

	/**
	 * @property {K4.Server} server The current server. Only created if {@link K4#cfg-server} is true and {@link K4#authenticate} is provided.
	 * @bridgeonly
	 */

	/**
	 * @property {K4.Client} client The current client. Only created if {@link K4#url}  and {@link K4#system} are provided.
	 */

	/**
	 * @property {K4.Watchdog} watchdog Watchdog for monitoring clients.
	 */

	/**
	 * @method K4
	 * Creates a new K4 object
	 * @param {Object} [config] Config object.
	 * @return {K4}
	 */


	class K4 extends events {

		constructor(config)
		{
			super(config);
			
			this.config = config;

			this.endpoints = new endpoints();
			this.util = new util();
			

			//platform specific setup
			if( isNode && !config.browser )
			{
				let node$1 = node;
				node$1.init(this);
			} else {
				let browser$1 = browser;
				browser$1.init(this);
			}

			this.watchdog = new watchdog(this);

			this.run();

		}

		

		

		close()
		{

			this.watchdog.close();

			if(this.client)
			{
				this.logging.system('Closing client with no reconnect');
				
				let io = this.client.io;
				io.io.skipReconnect = true;
				io.close();

				clearTimeout(this.client.reconnectTimer);
			}

			if(this.server)
			{
				this.logging.system('Closing servers');
				

				let io = this.server.io;
				let socketlist = io.sockets.sockets;

				this.logging.system('Closing ' + socketlist.length + ' server sockets');

				for(let i in socketlist)
				{
					socketlist[i].conn.close();
				}

				io.httpServer.close();
				io.close();
				
				this.server.app.close();

			}
			
		}


	}

	//mixins
	Object.assign(K4.prototype, ready);
	Object.assign(K4.prototype, run$2);

	if (isNode) {
	    module.exports = K4;
	}

	if(typeof window == 'object')
	{
		window.K4 = K4;
	}

	if(typeof commonjsGlobal == 'object')
	{
		commonjsGlobal.K4 = K4;
	}
	});

	return src;

}(io));
